import { BASE_PATH } from "../../constants";
const CUSTOMER_DETAILS_ENDPOINT = `${BASE_PATH}customers/me`;
const getCustomerDetailsRequestUrl = ({ baseUrl, xSiteOrigin, language, country, keyStoreDataversion, }) => {
    const url = new URL(CUSTOMER_DETAILS_ENDPOINT, baseUrl);
    url.search = new URLSearchParams({
        country,
        lang: language,
        keystoredataversion: keyStoreDataversion,
        ...(xSiteOrigin ? { "x-site-origin": xSiteOrigin } : {}),
    }).toString();
    return url.toString();
};
export default getCustomerDetailsRequestUrl;
